import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imAssignedToFilter', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/filters/assigned-to-filter/assigned-to-filter.html'),
        controller: 'AssignedToFilterController',
        controllerAs: 'AssignedToFilterCtrl',
        bindings: {
            assignedTo: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/filters/assigned-to-filter/assigned-to-filter.component.ts